import { useTrack } from '../../lib/entities';
import { player, usePlayer, useCurrentTrack } from '../../state/player';
import { Icon } from '../../components/ui/Icon';
import { IconButton } from '../../components/ui/primitives';
import { Cover } from './Cover';
import { useTrackActions } from './useTrackActions';
import styles from './player.module.css';

/** Persistent mini-player above the bottom nav; tap to open Now Playing. */
export function MiniPlayer() {
  const current = useCurrentTrack();
  const playing = usePlayer((s) => s.playing);
  const buffering = usePlayer((s) => s.buffering);
  const progress = usePlayer((s) => (s.duration ? s.position / s.duration : 0));
  const actions = useTrackActions();
  if (!current) return null;
  return <MiniPlayerInner track={current} playing={playing} buffering={buffering} progress={progress} onLike={() => actions.toggleLike(current)} />;
}

function MiniPlayerInner({ track: base, playing, buffering, progress, onLike }: { track: NonNullable<ReturnType<typeof useCurrentTrack>>; playing: boolean; buffering: boolean; progress: number; onLike: () => void }) {
  const track = useTrack(base);
  return (
    <div className={styles.mini} role="region" aria-label="Muziekspeler">
      <button className={styles.miniMain} onClick={() => player.setExpanded(true)} aria-label={`Open speler: ${track.title}`}>
        <Cover src={track.coverUrl} size={42} radius={8} />
        <span className={styles.miniText}>
          <span className={styles.miniTitle}>{track.title}</span>
          <span className={styles.miniSub}>{track.artist.name}</span>
        </span>
      </button>
      <IconButton icon="heart" label={track.liked ? 'Niet meer leuk' : 'Vind ik leuk'} active={track.liked} filled={track.liked} size={20} onClick={onLike} />
      <button className={styles.miniPlay} onClick={() => player.toggle()} aria-label={playing ? 'Pauze' : 'Afspelen'}>
        {buffering && playing ? <span className={styles.miniSpin} /> : <Icon name={playing ? 'pause' : 'play'} size={22} />}
      </button>
      <IconButton icon="next" label="Volgende" size={20} onClick={() => player.next()} />
      <span className={styles.miniProgress} style={{ transform: `scaleX(${progress})` }} />
    </div>
  );
}
